import { Controller } from '@hotwired/stimulus'
import Macy from 'macy'

export default class extends Controller {
    static values = {
        config: Object,
    }
    
    #masonry = null
    
    connect() {
        queueMicrotask(() => {
            this.#masonry = new Macy({
                ...this.configValue,
                ...{container: this.element}
            })
        })
    }

    disconnect() {
        this.#masonry?.remove()
    }
}
